import { jsx as l, jsxs as i } from "react/jsx-runtime";
import "react";
var o = (t) => /* @__PURE__ */ i("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  ...t,
  children: [
    /* @__PURE__ */ l("path", {
      d: "M20 0.000244141H0V19.9998H20V0.000244141Z",
      fill: "#D80027"
    }),
    /* @__PURE__ */ l("path", {
      d: "M20 0H0V6.66652H20V0Z",
      fill: "#F0F0F0"
    }),
    /* @__PURE__ */ l("path", {
      d: "M20 13.3335H0V20H20V13.3335Z",
      fill: "#FFDA44"
    })
  ]
});
export {
  o as default
};
